import { render, staticRenderFns } from "./acciones.vue?vue&type=template&id=163251f1&"
import script from "./acciones.component.ts?vue&type=script&lang=ts&"
export * from "./acciones.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports